import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getProductLists } from '../actions/ProductListActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane } from 'evergreen-ui';

class ListProductLists extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getProductLists(opts));
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/product-lists/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Lista de produse noua
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'position', label: 'Pozitie'},
                    {id: 'name', label: 'Nume'},
                    {id: 'slug', label: 'SLUG'},
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Updated', decorator: 'date'}
                ]}

                data={this.props.data}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}
                onTableChange={this.handleTableChange}

                itemMenu={[
                    { getLink: (item) => `/product-lists/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/product-lists/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.productLists;
}

export default connect(mapStateToProps)(ListProductLists);